module.exports = __webpack_public_path__ + "static/img/10.a1dc53b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/7/1/zh/10.png
// module id = fPQu
// module chunks = 0